import Repository from './Repository'
const action = 'approvements'

export default {
  fetchApprovements(rel = '') {
    let stats = '?total=1'

    if (rel) {
      stats = `?by_rel=${rel}&by_master=1`
    }

    return Repository.get(`${action}/stats${stats}`)
  },
  postApprovements(data) {
    return Repository.post(action, data)
  },
}
